// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_F7h","cls2":"ClaimEvaluationRow-cls2_9bn ClaimEvaluationRow-cls1_F7h"};